import React, { useState } from 'react';
import { 
  ChevronDown, ChevronRight, Check, Clock, Zap, Shield, Users, Brain, 
  Settings, Database, Code, Layers, Server, Lock, FileText, Palette,
  Sparkles, TrendingUp, AlertTriangle, CheckCircle2
} from 'lucide-react';

/**
 * Mapa de Funcionalidades do Author's Key
 * Seção colapsável com todas as features e datas de criação
 */
export const FeatureMap = ({ isExpanded, onToggle }) => {
  const [expandedCategories, setExpandedCategories] = useState({});

  const toggleCategory = (category) => {
    setExpandedCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  const features = {
    escrita: {
      icon: <FileText className="w-4 h-4" />,
      title: "Escrita",
      color: "text-blue-400",
      bgColor: "bg-blue-500/20",
      items: [
        { name: "Editor imersivo (TipTap)", status: "done", date: "2024-12", impact: 5, marketing: "Editor profissional para escritores" },
        { name: "Auto-save inteligente", status: "done", date: "2024-12", impact: 4, marketing: "Nunca perca seu trabalho" },
        { name: "Histórico de versões", status: "done", date: "2024-12", impact: 5, marketing: "Recupere qualquer versão anterior" },
        { name: "Post-its por capítulo", status: "done", date: "2025-01", impact: 3, marketing: "Organize suas ideias" },
        { name: "Post-it Rascunho (cor diferente)", status: "planned", date: null, impact: 3, marketing: "Separe rascunhos de notas" },
        { name: "Posfácio no editor", status: "planned", date: null, impact: 2, marketing: "Estrutura completa de livro" },
        { name: "Galeria de Personagens", status: "planned", date: null, impact: 4, marketing: "Visualize seus personagens" },
      ]
    },
    coautoria: {
      icon: <Users className="w-4 h-4" />,
      title: "Co-autoria",
      color: "text-amber-400",
      bgColor: "bg-amber-500/20",
      items: [
        { name: "Convite por email", status: "done", date: "2025-02", impact: 5, marketing: "Escreva a quatro mãos" },
        { name: "Certificado verificável (QR Code)", status: "done", date: "2025-02", impact: 5, marketing: "Prova digital de autoria" },
        { name: "Rastreio de contribuição", status: "done", date: "2025-02", impact: 5, marketing: "Saiba quem escreveu o quê" },
        { name: "Email jurídico de aceite", status: "done", date: "2025-04", impact: 5, marketing: "Validade jurídica garantida" },
        { name: "% de contribuição por autor", status: "done", date: "2025-02", impact: 4, marketing: "Contribuição transparente" },
        { name: "Proteção contra exclusão unilateral", status: "done", date: "2025-02", impact: 5, marketing: "Sua obra está segura" },
        { name: "Detecção de % copiado/colado", status: "planned", date: null, impact: 4, marketing: "Originalidade verificada" },
        { name: "Termo de exclusão com acordo", status: "planned", date: null, impact: 4, marketing: "Exclusão só em comum acordo" },
        { name: "Seção Documentos no Perfil", status: "planned", date: null, impact: 4, marketing: "Todos os documentos em um lugar" },
      ]
    },
    seguranca: {
      icon: <Shield className="w-4 h-4" />,
      title: "Segurança",
      color: "text-green-400",
      bgColor: "bg-green-500/20",
      items: [
        { name: "Autenticação 2FA (TOTP)", status: "done", date: "2025-03", impact: 5, marketing: "Proteção como bancos digitais" },
        { name: "Senhas criptografadas (bcrypt)", status: "done", date: "2024-12", impact: 5, marketing: "Padrão bancário de segurança" },
        { name: "Rate Limiting anti-ataques", status: "done", date: "2025-03", impact: 4, marketing: "Proteção automática contra ataques" },
        { name: "Tela de descanso com senha", status: "done", date: "2025-03", impact: 3, marketing: "Sua sessão protegida" },
        { name: "Limite 2 sessões simultâneas", status: "done", date: "2025-04", impact: 4, marketing: "Controle total de acessos" },
        { name: "Expiração 10 dias", status: "done", date: "2025-04", impact: 3, marketing: "Segurança automática" },
        { name: "Alerta novo dispositivo (email)", status: "done", date: "2025-04", impact: 4, marketing: "Saiba quem acessou" },
        { name: "Modal de regras de segurança", status: "done", date: "2025-04", impact: 3, marketing: "Transparência total" },
        { name: "Proteção contra zeramento", status: "done", date: "2025-04", impact: 5, marketing: "Backup automático de conteúdo" },
        { name: "Sanitização anti-injeção", status: "done", date: "2025-03", impact: 4, marketing: "Proteção contra hackers" },
        { name: "reCAPTCHA no login", status: "planned", date: null, impact: 3, marketing: "Bloqueio de bots" },
      ]
    },
    ia: {
      icon: <Brain className="w-4 h-4" />,
      title: "Inteligência Artificial",
      color: "text-purple-400",
      bgColor: "bg-purple-500/20",
      items: [
        { name: "Conselho Literário (GPT-4)", status: "done", date: "2025-01", impact: 5, marketing: "IA especializada para escritores" },
        { name: "Emulador Acelerador", status: "done", date: "2025-01", impact: 4, marketing: "Acelere sua escrita" },
        { name: "Concierge Speer", status: "done", date: "2025-03", impact: 4, marketing: "Assistente sempre disponível" },
        { name: "Auditora de Saúde do App", status: "done", date: "2025-03", impact: 4, marketing: "Monitoramento inteligente" },
        { name: "Estrategista de Melhorias", status: "done", date: "2025-03", impact: 4, marketing: "Sugestões proativas" },
        { name: "Biografia automática do autor", status: "planned", date: null, impact: 3, marketing: "Copywriter IA incluso" },
      ]
    },
    admin: {
      icon: <Settings className="w-4 h-4" />,
      title: "Administração",
      color: "text-red-400",
      bgColor: "bg-red-500/20",
      items: [
        { name: "Painel Saúde do App", status: "done", date: "2025-03", impact: 5, marketing: "Visão 360° do sistema" },
        { name: "Métricas em tempo real", status: "done", date: "2025-03", impact: 4, marketing: "Dados ao vivo" },
        { name: "Central de Inteligência (2 agentes)", status: "done", date: "2025-03", impact: 5, marketing: "IA auditora e estrategista" },
        { name: "Lista de usuários", status: "done", date: "2025-02", impact: 3, marketing: "Gestão de usuários" },
        { name: "Mapa de Funcionalidades", status: "done", date: "2025-04", impact: 3, marketing: "Visão do produto" },
        { name: "Arquitetura Técnica", status: "done", date: "2025-04", impact: 3, marketing: "Documentação para pitch" },
        { name: "Agente Humano Pontuais", status: "planned", date: null, impact: 4, marketing: "Reporte bugs facilmente" },
      ]
    },
    integracao: {
      icon: <Layers className="w-4 h-4" />,
      title: "Integrações",
      color: "text-cyan-400",
      bgColor: "bg-cyan-500/20",
      items: [
        { name: "Google OAuth", status: "done", date: "2024-12", impact: 5, marketing: "Login com Google" },
        { name: "Resend (emails)", status: "done", date: "2025-01", impact: 5, marketing: "Emails automáticos" },
        { name: "OpenAI GPT-4", status: "done", date: "2025-01", impact: 5, marketing: "IA de última geração" },
        { name: "Autentique (contratos)", status: "planned", date: null, impact: 4, marketing: "Assinatura digital certificada" },
        { name: "Biblioteca Nacional", status: "planned", date: null, impact: 3, marketing: "Registro ISBN facilitado" },
        { name: "INPI (marcas/patentes)", status: "planned", date: null, impact: 3, marketing: "Pesquisa de marcas" },
      ]
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'done':
        return <span className="px-2 py-0.5 text-xs font-medium bg-green-500/20 text-green-400 rounded-full flex items-center gap-1"><CheckCircle2 className="w-3 h-3" /> Pronto</span>;
      case 'progress':
        return <span className="px-2 py-0.5 text-xs font-medium bg-amber-500/20 text-amber-400 rounded-full flex items-center gap-1"><Clock className="w-3 h-3" /> Em progresso</span>;
      case 'planned':
        return <span className="px-2 py-0.5 text-xs font-medium bg-stone-500/20 text-stone-400 rounded-full flex items-center gap-1"><TrendingUp className="w-3 h-3" /> Planejado</span>;
      default:
        return null;
    }
  };

  const getImpactStars = (impact) => {
    return Array(5).fill(0).map((_, i) => (
      <Sparkles key={i} className={`w-3 h-3 ${i < impact ? 'text-amber-400' : 'text-stone-600'}`} />
    ));
  };

  // Calcula estatísticas
  const allItems = Object.values(features).flatMap(cat => cat.items);
  const doneCount = allItems.filter(i => i.status === 'done').length;
  const plannedCount = allItems.filter(i => i.status === 'planned').length;
  const totalCount = allItems.length;

  return (
    <div className="bg-stone-800/50 rounded-xl border border-stone-700/50 overflow-hidden">
      {/* Header colapsável */}
      <button
        onClick={onToggle}
        className="w-full px-6 py-4 flex items-center justify-between hover:bg-stone-800/70 transition-colors"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center">
            <Layers className="w-5 h-5 text-white" />
          </div>
          <div className="text-left">
            <h3 className="text-lg font-medium text-white">Mapa de Funcionalidades</h3>
            <p className="text-sm text-stone-400">
              {doneCount} prontas • {plannedCount} planejadas • {totalCount} total
            </p>
          </div>
        </div>
        {isExpanded ? (
          <ChevronDown className="w-5 h-5 text-stone-400" />
        ) : (
          <ChevronRight className="w-5 h-5 text-stone-400" />
        )}
      </button>

      {/* Conteúdo expandido */}
      {isExpanded && (
        <div className="px-6 pb-6 space-y-4">
          {Object.entries(features).map(([key, category]) => (
            <div key={key} className="border border-stone-700/50 rounded-lg overflow-hidden">
              {/* Categoria header */}
              <button
                onClick={() => toggleCategory(key)}
                className="w-full px-4 py-3 flex items-center justify-between bg-stone-900/50 hover:bg-stone-900/70 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <div className={`w-8 h-8 rounded-lg ${category.bgColor} flex items-center justify-center ${category.color}`}>
                    {category.icon}
                  </div>
                  <span className="font-medium text-white">{category.title}</span>
                  <span className="text-xs text-stone-500">
                    ({category.items.filter(i => i.status === 'done').length}/{category.items.length})
                  </span>
                </div>
                {expandedCategories[key] ? (
                  <ChevronDown className="w-4 h-4 text-stone-400" />
                ) : (
                  <ChevronRight className="w-4 h-4 text-stone-400" />
                )}
              </button>

              {/* Items da categoria */}
              {expandedCategories[key] && (
                <div className="divide-y divide-stone-700/50">
                  {category.items.map((item, idx) => (
                    <div key={idx} className="px-4 py-3 flex items-center justify-between bg-stone-800/30">
                      <div className="flex-1">
                        <div className="flex items-center gap-2">
                          <span className="text-sm text-white">{item.name}</span>
                          {getStatusBadge(item.status)}
                        </div>
                        <p className="text-xs text-stone-500 mt-1">{item.marketing}</p>
                      </div>
                      <div className="flex items-center gap-4">
                        <div className="flex items-center gap-0.5" title="Impacto para marketing">
                          {getImpactStars(item.impact)}
                        </div>
                        <span className="text-xs text-stone-500 w-20 text-right">
                          {item.date || 'Futuro'}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


/**
 * Arquitetura Técnica do Author's Key
 * Glossário + Frases de Pitch para apresentações
 */
export const TechArchitecture = ({ isExpanded, onToggle }) => {
  const [activeTab, setActiveTab] = useState('stack');

  const techCategories = {
    stack: {
      title: "Stack Tecnológico",
      icon: <Code className="w-4 h-4" />,
      items: [
        { term: "React", what: "Biblioteca JavaScript para interfaces", why: "Usado por Facebook, Instagram, Netflix", pitch: "Nossa interface é construída em React, a mesma tecnologia do Facebook" },
        { term: "FastAPI", what: "Framework Python para backend", why: "Rápido, moderno, usado por Microsoft e Netflix", pitch: "Nosso servidor usa FastAPI, conhecido pela alta performance" },
        { term: "MongoDB", what: "Banco de dados não-relacional", why: "Flexível para documentos de texto variável", pitch: "Usamos MongoDB, ideal para armazenar textos literários de qualquer tamanho" },
        { term: "Tailwind CSS", what: "Sistema de estilização", why: "Design consistente e responsivo", pitch: "Interface responsiva que funciona em qualquer dispositivo" },
      ]
    },
    security: {
      title: "Segurança",
      icon: <Lock className="w-4 h-4" />,
      items: [
        { term: "2FA / TOTP", what: "Autenticação em dois fatores", why: "Mesmo com senha vazada, conta protegida", pitch: "Proteção de dois fatores como bancos digitais" },
        { term: "Hash bcrypt", what: "Senha criptografada irreversivelmente", why: "Nem nós conseguimos ver sua senha", pitch: "Senhas criptografadas com padrão bancário" },
        { term: "Rate Limiting", what: "Limite de requisições por tempo", why: "Bloqueia ataques de força bruta", pitch: "Proteção automática contra ataques" },
        { term: "Sessão com expiração", what: "Login temporário", why: "Segurança em dispositivos compartilhados", pitch: "Sessões expiram automaticamente por segurança" },
        { term: "Audit Logs", what: "Registro de todas as ações", why: "Rastreabilidade para disputas", pitch: "Toda ação é registrada com data e hora" },
        { term: "Sanitização de input", what: "Limpeza de dados maliciosos", why: "Previne injeção de código", pitch: "Proteção contra ataques de injeção" },
      ]
    },
    integrity: {
      title: "Integridade de Dados",
      icon: <Database className="w-4 h-4" />,
      items: [
        { term: "Hash de integridade", what: "Impressão digital do conteúdo", why: "Prova que o texto não foi alterado", pitch: "Cada versão tem uma assinatura digital única" },
        { term: "Versionamento", what: "Histórico de todas as versões", why: "Recuperar versões anteriores", pitch: "Nunca perca seu trabalho - todas as versões são guardadas" },
        { term: "Índices MongoDB", what: "Catálogo organizado de dados", why: "Buscas instantâneas", pitch: "Performance otimizada mesmo com milhares de capítulos" },
        { term: "Backup automático", what: "Cópia de segurança periódica", why: "Recuperação em caso de falha", pitch: "Seus dados são copiados automaticamente" },
        { term: "Proteção zeramento", what: "Bloqueio de saves vazios", why: "Previne perda de conteúdo", pitch: "Proteção automática contra perda de texto" },
      ]
    },
    coauthorship: {
      title: "Co-autoria",
      icon: <Users className="w-4 h-4" />,
      items: [
        { term: "Rastreio de contribuição", what: "Registro de quem escreveu o quê", why: "Prova de autoria individual", pitch: "Sabemos exatamente quem escreveu cada parte" },
        { term: "Certificado verificável", what: "Documento com QR Code", why: "Prova pública de autoria", pitch: "Certificado digital verificável por qualquer pessoa" },
        { term: "Aceite formal auditado", what: "Registro legal do aceite", why: "Validade jurídica", pitch: "Co-autoria com registro formal, válido juridicamente" },
        { term: "Criptografia indelével", what: "Proteção de ponta a ponta", why: "Privacidade total", pitch: "Sua obra é criptografada - nem nós temos acesso" },
      ]
    },
    ai: {
      title: "Inteligência Artificial",
      icon: <Brain className="w-4 h-4" />,
      items: [
        { term: "LLM (Large Language Model)", what: "IA treinada em textos", why: "Assistência inteligente", pitch: "IA treinada em milhões de textos literários" },
        { term: "GPT-4", what: "Modelo da OpenAI", why: "Alta qualidade de sugestões", pitch: "Usamos a mesma IA do ChatGPT" },
        { term: "Prompt engineering", what: "Arte de instruir a IA", why: "Respostas específicas para escritores", pitch: "IA especializada para escritores, não genérica" },
        { term: "Contexto de sessão", what: "IA 'lembra' a conversa", why: "Continuidade no diálogo", pitch: "A IA entende o contexto do seu livro" },
      ]
    },
    architecture: {
      title: "Arquitetura",
      icon: <Server className="w-4 h-4" />,
      items: [
        { term: "API RESTful", what: "Comunicação padronizada", why: "Integrações futuras facilitadas", pitch: "Arquitetura moderna e extensível" },
        { term: "Middleware", what: "Camada de proteção", why: "Segurança em cada requisição", pitch: "Múltiplas camadas de segurança" },
        { term: "Hot Reload", what: "Atualização sem derrubar", why: "Zero downtime", pitch: "Atualizações sem interrupção do serviço" },
        { term: "Stateless", what: "Servidor sem memória de estado", why: "Escala facilmente", pitch: "Preparado para milhares de usuários simultâneos" },
      ]
    }
  };

  const pitchPhrases = {
    construction: {
      question: "Como foi construído?",
      answer: "O Author's Key foi desenvolvido com tecnologias usadas por empresas como Netflix e Facebook. Usamos React no frontend, FastAPI no backend, e MongoDB como banco de dados. É uma arquitetura moderna, escalável e segura."
    },
    security: {
      question: "É seguro?",
      answer: "Implementamos segurança em múltiplas camadas: autenticação de dois fatores, senhas criptografadas com padrão bancário, proteção contra ataques, e registro auditável de todas as ações. É o mesmo nível de segurança de fintechs."
    },
    coauthorship: {
      question: "E a co-autoria, como funciona?",
      answer: "Cada contribuição é rastreada automaticamente - sabemos quem escreveu o quê e quando. Geramos certificados verificáveis com QR Code e hash criptográfico. É prova digital de autoria com validade jurídica."
    },
    ai: {
      question: "Vocês usam IA?",
      answer: "Sim, integramos modelos de linguagem avançados como GPT-4, mas de forma especializada para escritores. Nossa IA não escreve pelo autor - ela auxilia, sugere e orienta, mantendo a autoria humana no centro."
    },
    scale: {
      question: "Escala?",
      answer: "A arquitetura é stateless e usa banco de dados distribuído. Podemos ir de 10 a 10.000 usuários ajustando infraestrutura, sem reescrever código."
    }
  };

  return (
    <div className="bg-stone-800/50 rounded-xl border border-stone-700/50 overflow-hidden">
      {/* Header colapsável */}
      <button
        onClick={onToggle}
        className="w-full px-6 py-4 flex items-center justify-between hover:bg-stone-800/70 transition-colors"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-emerald-500 to-teal-500 flex items-center justify-center">
            <Code className="w-5 h-5 text-white" />
          </div>
          <div className="text-left">
            <h3 className="text-lg font-medium text-white">Arquitetura Técnica</h3>
            <p className="text-sm text-stone-400">Glossário + Frases de Pitch</p>
          </div>
        </div>
        {isExpanded ? (
          <ChevronDown className="w-5 h-5 text-stone-400" />
        ) : (
          <ChevronRight className="w-5 h-5 text-stone-400" />
        )}
      </button>

      {/* Conteúdo expandido */}
      {isExpanded && (
        <div className="px-6 pb-6">
          {/* Tabs */}
          <div className="flex flex-wrap gap-2 mb-4">
            {Object.entries(techCategories).map(([key, cat]) => (
              <button
                key={key}
                onClick={() => setActiveTab(key)}
                className={`px-3 py-1.5 text-sm rounded-lg flex items-center gap-2 transition-colors ${
                  activeTab === key
                    ? 'bg-amber-500 text-stone-900'
                    : 'bg-stone-700 text-stone-300 hover:bg-stone-600'
                }`}
              >
                {cat.icon}
                {cat.title}
              </button>
            ))}
            <button
              onClick={() => setActiveTab('pitch')}
              className={`px-3 py-1.5 text-sm rounded-lg flex items-center gap-2 transition-colors ${
                activeTab === 'pitch'
                  ? 'bg-amber-500 text-stone-900'
                  : 'bg-stone-700 text-stone-300 hover:bg-stone-600'
              }`}
            >
              <Sparkles className="w-4 h-4" />
              Frases de Pitch
            </button>
          </div>

          {/* Conteúdo da tab ativa */}
          {activeTab === 'pitch' ? (
            <div className="space-y-4">
              <p className="text-sm text-stone-400 mb-4">
                Frases prontas para responder perguntas em apresentações e pitches:
              </p>
              {Object.entries(pitchPhrases).map(([key, item]) => (
                <div key={key} className="bg-stone-900/50 rounded-lg p-4 border border-stone-700/50">
                  <p className="text-amber-400 font-medium mb-2">"{item.question}"</p>
                  <p className="text-stone-300 text-sm leading-relaxed">{item.answer}</p>
                </div>
              ))}
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-stone-700">
                    <th className="text-left py-2 px-3 text-stone-400 font-medium">Termo</th>
                    <th className="text-left py-2 px-3 text-stone-400 font-medium">O Que É</th>
                    <th className="text-left py-2 px-3 text-stone-400 font-medium">Por Que Usamos</th>
                    <th className="text-left py-2 px-3 text-stone-400 font-medium">Frase para Pitch</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-stone-700/50">
                  {techCategories[activeTab]?.items.map((item, idx) => (
                    <tr key={idx} className="hover:bg-stone-800/50">
                      <td className="py-3 px-3 text-white font-medium">{item.term}</td>
                      <td className="py-3 px-3 text-stone-300">{item.what}</td>
                      <td className="py-3 px-3 text-stone-400">{item.why}</td>
                      <td className="py-3 px-3 text-amber-300 italic">"{item.pitch}"</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default { FeatureMap, TechArchitecture };
